import { render, staticRenderFns } from "./EditTrafficLabel.vue?vue&type=template&id=cd65283a&scoped=true&"
import script from "./EditTrafficLabel.vue?vue&type=script&lang=js&"
export * from "./EditTrafficLabel.vue?vue&type=script&lang=js&"
import style0 from "./EditTrafficLabel.vue?vue&type=style&index=0&id=cd65283a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd65283a",
  null
  
)

export default component.exports